<template>
  <table class="table table-striped table-hover caption-top">
    <thead>
      <tr>
        <th v-if="showIndex" @click="$emit('sort')">
          <div class="sort-header">
            <span>{{ indexLabel }}</span>
            <nav class="sort-icons">
                <font-awesome-icon icon="sort-up" :class="{ selected: sortAsc }" />
                <font-awesome-icon icon="sort-down" :class="{ selected: !sortAsc }" />
            </nav>
          </div>
        </th>
        <th v-for="col in columns" :key="col.key">{{ col.label }}</th> 
      </tr> 
    </thead>

    <tbody>
      <tr v-for="(item, index) in items" :key="index">
        <td>{{ index + 1 }}</td>
        <td v-for="col in columns" :key="col.key">
          <slot :name="col.key" :item="item">
            {{ item[col.key] }}
          </slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export interface TableColumn {
  key: string;
  label: string;
}

export default defineComponent({
  name: 'GenericTable',
  props: {
    showIndex: {
        type: Boolean,
        default: true,
    },
    indexLabel: {
        type: String,
        default: 'No.',
    },
    items: {
      type: Array as PropType<Record<string, any>[]>,
      required: true,
    },
    columns: {
      type: Array as PropType<TableColumn[]>,
      required: true,
    },
    sortAsc: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style lang="scss">
.sort-header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.sort-icons {
  position: relative;
  width: 1rem;
  height: 1rem;
  margin-left: 5px;
  
  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: var(--bs-gray-600);
    cursor: pointer;

    &.selected {
      color: var(--bs-info);
    }
  }
}
</style>
